import React from 'react';
import './components.css';
import mistbornCover from './img/mistborn-cover.jpg';

const books = [
  {
    title: 'Mistborn',
    author: 'Brandon Sanderson',
    blurb: 'A sharp, cinematic fantasy heist with ash-filled skies and unforgettable magic.',
    pick: 'Highlighted Fantasy',
    coverImage: mistbornCover,
    coverFallback: 'linear-gradient(145deg, #3B3329 0%, #1F1915 100%)',
  },
  {
    title: 'A Court of Thorns and Roses',
    author: 'Sarah J. Maas',
    blurb: 'Romantasy with teeth: dangerous fae, high stakes, and a story readers devour.',
    pick: 'Highlighted Fantasy',
    coverImage: 'https://covers.openlibrary.org/b/id/13774033-L.jpg',
    coverFallback: 'linear-gradient(145deg, #261D1B 0%, #140F0E 100%)',
  },
  {
    title: 'Fourth Wing',
    author: 'Rebecca Yarros',
    blurb: 'A high-voltage dragon rider fantasy that earns every bit of its hype.',
    pick: 'Highlighted Fantasy',
    coverImage: 'https://covers.openlibrary.org/b/id/14588041-L.jpg',
    coverFallback: 'linear-gradient(145deg, #C69A34 0%, #7A5A12 100%)',
  },
  {
    title: 'Fablehaven: Grip of the Shadow Plague',
    author: 'Brandon Mull',
    blurb: 'Fast-paced middle grade fantasy with real adventure energy and big series appeal.',
    pick: 'Highlighted Fantasy',
    coverImage: 'https://covers.openlibrary.org/b/isbn/9781590388983-L.jpg',
    coverFallback: 'linear-gradient(145deg, #365138 0%, #1E2F20 100%)',
  },
];

function FeaturedBooks() {
  return (
    <section className="featured" id="featured">
      <div className="section-head">
        <span className="kicker">01 — From The Shelf</span>
        <h2 className="section-title">Featured this month</h2>
        <p className="section-lede">
          A small, changing stack of the books we can't stop recommending — pulled straight from the front counter.
        </p>
      </div>

      <div className="featured-grid">
        {books.map((b) => (
          <article className="book-card" key={b.title}>
            <div className="book-cover-frame">
              <div
                className="book-cover"
                style={{
                  background: b.coverFallback,
                }}
              >
                <img
                  className="book-cover-image"
                  src={b.coverImage}
                  alt={`${b.title} by ${b.author}`}
                  loading="lazy"
                />
              </div>
            </div>
            <p className="book-pick">{b.pick}</p>
            <h3 className="book-title">{b.title}</h3>
            <p className="book-author">by {b.author}</p>
            <p className="book-blurb">{b.blurb}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default FeaturedBooks;
